import {Component, Inject, OnInit} from "@angular/core";
import {FormBuilder, FormGroup} from "@angular/forms";
import {MatDialogRef, MAT_DIALOG_DATA} from "@angular/material/dialog";
import {Video} from "src/app/model/video-youtube/video-youtube";
import {i18nService} from "src/app/service-utils/i18n.service";
import {requiredFieldValidator} from "../../validation/validators";

@Component({
  selector: 'app-youtube-video-dialog',
  templateUrl: './youtube-video-dialog.component.html',
  styleUrls: ['./youtube-video-dialog.component.scss']
})
export class YoutubeVideoDialogComponent implements OnInit {

  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<YoutubeVideoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public i18nService: i18nService,
    private formBuilder: FormBuilder,
  ) {
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      url: [this.data?.url, requiredFieldValidator()],
      description: [this.data?.description, requiredFieldValidator()]
    });
  }

  save() {
    this.form.get('url').markAsTouched();
    this.form.get('description').markAsTouched();

    if(this.form.valid) {
      let newVideo: Video = {
        id: null,
        description: this.form.get("description").value,
        url: this.form.get("url").value
      };
      if (this.data) {
        newVideo.id = this.data.id;
      }
      this.dialogRef.close({data: newVideo});
    }
  }

  discard() {
    this.dialogRef.close();
  }
}
